/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import Avatar from "../../Images/users/avatar-2.jpg";
import Avatar1 from "../../Images/users/avatar-3.jpg";
import Avatar2 from "../../Images/users/avatar-9.jpg";
import Avatar3 from "../../Images/users/avatar-6.jpg";
import { FaRegBell, FaChevronDown, FaPlus } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";
import { MdHelpOutline } from "react-icons/md";
import { FaRegMoon } from "react-icons/fa";
import { LuSun, LuSettings, LuLogOut, LuUser, LuLayoutDashboard } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../Redux/AuthSlice";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ImageUrl } from "../Common/API";

const Navbar = ({ isVisible, setIsVisible, isDark, setIsDark }) => {
  const { userDetails } = useSelector((state) => state.root.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const queryClient = useQueryClient();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchFocus, setSearchFocus] = useState(false);
  const [logout, setLogout] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const toggle = (name) => setOpenDropdown((prev) => (prev === name ? null : name));

  const initials = userDetails?.userName
    ? userDetails.userName
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2)
    : "D";

  const notifications = [
    { avatar: Avatar, name: "Sarah Johnson", text: "Assigned task 'Landing page' to you", time: "2 min ago", unread: true },
    { avatar: Avatar1, name: "Project Update", text: "Website Redesign moved to In Progress", time: "15 min ago", unread: true },
    { avatar: Avatar2, name: "Robert McCray", text: "Left a comment on your task", time: "1 hr ago", unread: false },
    { avatar: Avatar3, name: "Meeting Reminder", text: "Standup in 30 minutes", time: "2 hr ago", unread: false },
  ];
  const unreadCount = notifications.filter((n) => n.unread).length;

  return (
    <div className="disploy-topbar-wrap print:hidden" ref={dropdownRef}>
      <header className="h-16 bg-white border-b border-slate-100 flex items-center justify-between px-6 shadow-sm">
        {/* Left Section: Sidebar Toggle & Search */}
        <div className="flex items-center gap-4 flex-1">
          <button
            onClick={() => setIsVisible(!isVisible)}
            className="disploy-menu-toggle p-2 rounded-lg text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors"
            title="Toggle Sidebar"
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>

          {/* Search Input Box */}
          {/* <div
            className={`flex items-center gap-2.5 bg-slate-50 border rounded-xl px-3.5 py-2 w-full max-w-sm transition-all duration-150 ${searchFocus ? "border-indigo-600 bg-white ring-2 ring-indigo-50" : "border-slate-100"
              }`}
          >
            <IoSearch size={16} className="text-slate-400" />
            <input
              type="text"
              placeholder="Search projects, clients, members..."
              value={searchVal}
              onChange={(e) => setSearchVal(e.target.value)}
              onFocus={() => setSearchFocus(true)}
              onBlur={() => setSearchFocus(false)}
              className="flex-1 bg-transparent border-none outline-none text-xs text-slate-700 placeholder-slate-400"
            />
            <kbd className="text-[9px] font-bold text-slate-400 bg-slate-200/60 px-1.5 py-0.5 rounded">⌘ K</kbd>
          </div> */}
        </div>

        {/* Right Section: Actions & Utilities */}
        <div className="flex items-center gap-3">


          {/* Theme Mode Toggle */}
          {/* <button
            onClick={() => setIsDark(!isDark)}
            className="p-2 rounded-xl text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors"
            title={isDark ? "Light Mode" : "Dark Mode"}
          >
            {isDark ? <LuSun size={17} /> : <FaRegMoon size={16} />}
          </button> */}

          {/* Notifications Dropdown */}
          {/* <div className="relative">
            <button
              onClick={() => toggle("bell")}
              className="p-2 rounded-xl text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors relative"
              title="Notifications"
            >
              <FaRegBell size={17} />
              {unreadCount > 0 && (
                <span className="absolute top-1.5 right-1.5 w-4 h-4 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center border-2 border-white">
                  {unreadCount}
                </span>
              )}
            </button>

            {openDropdown === "bell" && (
              <div className="absolute right-0 mt-2 w-80 bg-white border border-slate-100 rounded-xl shadow-xl z-50 overflow-hidden">
                <div className="flex items-center justify-between p-4 border-b border-slate-50">
                  <span className="font-bold text-slate-800 text-sm">Notifications</span>
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-indigo-50 text-indigo-600">
                    {unreadCount} new
                  </span>
                </div>
                <div className="max-h-72 overflow-y-auto">
                  {notifications.map((n, i) => (
                    <div
                      key={i}
                      className={`flex gap-3 p-4 hover:bg-slate-50/50 cursor-pointer transition-colors ${n.unread ? "bg-slate-50/20" : ""
                        }`}
                    >
                      <div className="relative flex-shrink-0">
                        <img src={n.avatar} alt={n.name} className="w-9 h-9 rounded-full object-cover" />
                        {n.unread && <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-indigo-600 rounded-full border-2 border-white"></span>}
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-xs font-semibold text-slate-800 truncate">{n.name}</p>
                        <p className="text-[11px] text-slate-500 truncate mt-0.5">{n.text}</p>
                        <p className="text-[10px] text-indigo-600 mt-1">{n.time}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="p-3 border-t border-slate-50 text-center">
                  <button className="text-xs font-bold text-indigo-600 hover:text-indigo-700 transition-colors">
                    View all notifications
                  </button>
                </div>
              </div>
            )}
          </div> */}

          {/* Help & Support Dropdown */}
          {/* <div className="relative">
            <button
              onClick={() => toggle("help")}
              className="p-2 rounded-xl text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors"
              title="Help & Support"
            >
              <MdHelpOutline size={19} />
            </button>

            {openDropdown === "help" && (
              <div className="absolute right-0 mt-2 w-64 bg-white border border-slate-100 rounded-xl shadow-xl z-50 overflow-hidden">
                <div className="p-4 border-b border-slate-50">
                  <span className="font-bold text-slate-800 text-sm">Help & Resources</span>
                </div>
                <div className="p-2 space-y-1">
                  {[
                    { emoji: "📚", title: "Documentation", desc: "Guides and API references" },
                    { emoji: "💬", title: "Support Chat", desc: "Talk to our support team" },
                    { emoji: "🎥", title: "Video Tutorials", desc: "Step-by-step walkthroughs" },
                  ].map((r, i) => (
                    <div key={i} className="flex gap-3 p-2.5 hover:bg-slate-50 rounded-lg cursor-pointer transition-colors">
                      <span className="text-lg w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center flex-shrink-0">{r.emoji}</span>
                      <div>
                        <p className="text-xs font-semibold text-slate-800">{r.title}</p>
                        <p className="text-[10px] text-slate-500 mt-0.5">{r.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div> */}

          {/* User Profile */}
          <div className="relative">
            <button
              onClick={() => toggle("user")}
              className="flex items-center gap-2.5 p-1.5 hover:bg-slate-50 rounded-xl transition-all"
            >
              <div className="w-8 h-8 rounded-full overflow-hidden bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold border border-slate-100">
                {userDetails?.profilePic ? (
                  <img src={`${userDetails?.profilePic}`} alt="user" className="w-full h-full object-cover" />
                ) : (
                  <span>{initials}</span>
                )}
              </div>
            </button>

            {openDropdown === "user" && (
              <div className="absolute right-0 mt-2 w-56 bg-white border border-slate-100 rounded-xl shadow-xl z-50 overflow-hidden">
                <div className="p-4 bg-indigo-50/20 border-b border-slate-50 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-indigo-100 text-indigo-700 flex items-center justify-center text-sm font-bold flex-shrink-0">
                    {userDetails?.profilePic ? (
                      <img src={`${userDetails?.profilePic}`} alt="user" className="w-full h-full object-cover" />
                    ) : (
                      <span>{initials}</span>
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs font-bold text-slate-800 truncate">{userDetails?.userName || "Dhruv Admin"}</p>
                    <p className="text-[10px] text-slate-400 truncate mt-0.5">{userDetails?.email || "admin@disploy.com"}</p>
                  </div>
                </div>
                <div className="p-1.5 space-y-0.5">
                  {/* {[
                    { icon: <LuUser size={14} />, label: "My Profile", action: () => { } },
                  ].map((m, i) => (
                    <button
                      key={i}
                      onClick={() => { m.action(); setOpenDropdown(null); }}
                      className="w-full flex items-center gap-2.5 px-3.5 py-2 text-xs text-slate-600 hover:text-indigo-600 hover:bg-slate-50 rounded-lg transition-colors text-left font-medium"
                    >
                      {m.icon}
                      <span>{m.label}</span>
                    </button>
                  ))} */}
                  <div className="h-px bg-slate-50 my-1"></div>
                  <button
                    onClick={() => {
                      toast.loading("Logout...");
                      setLogout(true);
                      setTimeout(() => { queryClient.clear(); dispatch(handleLogout()); toast.remove(); navigate("/"); }, 1000);
                    }}
                    disabled={logout}
                    className="w-full flex items-center gap-2.5 px-3.5 py-2 text-xs text-red-600 hover:bg-red-50 rounded-lg transition-colors text-left font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <LuLogOut size={14} />
                    <span>Log Out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
